import React from 'react';
import giftCard from '../../styles/img/reward/gift_card.svg';
import give from '../../styles/img/reward/give.svg';
import transfer from '../../styles/img/reward/transfert.svg';

const RewardConvert = ({ showGiftCards }) => {
  return (
    // <div className="reward-convert ">
    //   <div className="convert-container">
    //     <div className="convert-item" onClick={showGiftCards}>
    //       <img className="convert-img" src={giftCard} alt="" />
    //       <span className="item-label">Carte cadeau</span>
    //     </div>
    //   <div className="convert-item disabled">
    //     <img className="convert-img" src={give} alt="" />
    //     <span className="item-label">Pour une asso</span>
    //   </div>
    // <div className="convert-item disabled">
    //   <img className="convert-img" src={transfer} alt="" />
    //   <span className="item-label">Virement</span>
    // </div>
    //   </div>
    // </div>
    <></>
  );
};

export default RewardConvert;
